import state from './';
import { NoValue } from '@vaaas/fpts/data';
import { uil_set_display_face_triangulation_res } from '../ui_logic';
import { withSpinner } from '../state/spinner';

/** get or set display triangles, updating the triangle approximation in the process
 *
 * pass a value to update the number of triangles, returning the new value
 *
 * pass nothing to get the number of triangles without change
 */
export default function triangles(x: typeof NoValue | number = NoValue): number {
    if (x === NoValue)
        return state.triangles;
    else {
        state.triangles = x;
        uil_set_display_face_triangulation_res(x);
        return x;
    }
}

export const triangles_with_spinner = withSpinner('Setting display triangles', triangles);
